import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { app } from '../firebase';
import {
    getFirestore,
    collection,
    getDocs,
    addDoc,
    Timestamp,
    query,
    orderBy
} from 'firebase/firestore';
import logo from '../Images/logoblack.svg'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


function ManualDash() {
    const db = getFirestore(app);
    const [showModal, setShowModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [clients, setClients] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [items, setItems] = useState([{ orderId: '', orderFrom: '', date: '', amount: 0 }]);
    const [previousBalance, setPreviousBalance] = useState(0);
    const [loading, setLoading] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);

    // Fetch clients
    useEffect(() => {
        const fetchClients = async () => {
            const snapshot = await getDocs(collection(db, 'clients'));
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setClients(data);
        };
        fetchClients();
    }, [db]);

    // Fetch invoices
    const fetchInvoices = async () => {
        const q = query(collection(db, 'manualInvoice'), orderBy('createdAt', 'desc'));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setInvoices(data);
    };

    useEffect(() => {
        fetchInvoices();
    }, [db]);

    const handleAddItem = () => {
        setItems([...items, { orderId: '', orderFrom: '', date: '', amount: 0 }]);
    };

    const handleItemChange = (index, field, value) => {
        const updated = [...items];
        updated[index][field] = value;
        setItems(updated);
    };

    const totalAmount = items.reduce((sum, i) => sum + Number(i.amount || 0), 0);
    const grandTotal = totalAmount + Number(previousBalance || 0);

    const handleSendInvoice = async () => {
        if (!selectedClient) {
            alert('Select a client first');
            return;
        }

        setLoading(true);
        try {
            await addDoc(collection(db, 'manualInvoice'), {
                clientId: selectedClient,
                items,
                previousBalance,
                totalAmount,
                grandTotal,
                createdAt: Timestamp.now()
            });

            alert('Invoice recorded successfully');
            setShowModal(false);
            setItems([{ orderId: '', orderFrom: '', date: '', amount: 0 }]);
            setSelectedClient('');
            setPreviousBalance(0);
            fetchInvoices();
        } catch (error) {
            console.error('Error recording invoice:', error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const getClientName = (id) => {
        const client = clients.find(c => c.id === id);
        return client ? client.full_name || client.businessName || 'Unnamed Client' : 'Unknown Client';
    };

    const normalizedSearch = searchTerm.trim().toLowerCase();
    const filteredInvoices = invoices.filter((inv) => {
        if (!normalizedSearch) return true;
        const clientName = getClientName(inv.clientId);
        const values = [
            clientName,
            inv.id,
            inv.clientId,
            inv.createdAt?.toDate().toLocaleDateString(),
            inv.totalAmount,
            inv.grandTotal,
            inv.previousBalance
        ];
        return values.some((value) =>
            String(value || '').toLowerCase().includes(normalizedSearch)
        );
    });


    const handleDownloadPDF = async () => {
        const invoiceElement = document.getElementById('invoice-preview');
        if (!invoiceElement) return;

        const canvas = await html2canvas(invoiceElement, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');

        const imgWidth = 190;
        const pageHeight = 295;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 10;

        pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }

        pdf.save(`invoice_${selectedInvoice.id}.pdf`);
    };


    return (
        <div>
            <div className="dataCompTop">
                <h5>All My Invoices</h5>
                <div className="searchContainer">
                    <FontAwesomeIcon icon={faSearch} className="searchIcon" />
                    <input
                        type="text"
                        placeholder="Type to search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button>Go</button>
                    <button onClick={() => setShowModal(true)}>
                        Record Invoice
                    </button>
                </div>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Client Name</th>
                        <th>Total Items</th>
                        <th>Total Amount</th>
                        <th>Previous Balance</th>
                        <th>Grand Total</th>
                        <th>Date</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {invoices.length === 0 ? (
                        <tr>
                            <td colSpan="7" className="text-center">No invoices recorded yet</td>
                        </tr>
                    ) : (
                        filteredInvoices.map(inv => (
                            <tr key={inv.id}>
                                <td>{getClientName(inv.clientId)}</td>
                                <td>{inv.items?.length || 0}</td>
                                <td>KES {Number(inv.totalAmount || 0).toFixed(2)}</td>
                                <td>KES {Number(inv.previousBalance || 0).toFixed(2)}</td>
                                <td><strong>KES {Number(inv.grandTotal || 0).toFixed(2)}</strong></td>

                                <td>{inv.createdAt?.toDate().toLocaleDateString()}</td>
                                <td>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() => {
                                            setSelectedInvoice(inv);
                                            setShowViewModal(true);
                                        }}
                                    >
                                        View
                                    </Button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>

            {/* Record Invoice Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Record an Invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Client</Form.Label>
                            <Form.Select
                                value={selectedClient}
                                onChange={(e) => setSelectedClient(e.target.value)}
                            >
                                <option value="">-- Select Client --</option>
                                {clients.map(client => (
                                    <option key={client.id} value={client.id}>
                                        {client.full_name} ({client.businessName})
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <h6>Invoice Items</h6>
                        <Table bordered size="sm">
                            <thead>
                                <tr>
                                    <th>Location</th>
                                    <th>Date</th>
                                    <th>Rate (KES)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, i) => (
                                    <tr key={i}>

                                        <td>
                                            <Form.Control
                                                type="text"
                                                value={item.orderFrom}
                                                onChange={(e) => handleItemChange(i, 'orderFrom', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="date"
                                                value={item.date}
                                                onChange={(e) => handleItemChange(i, 'date', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                value={item.amount}
                                                onChange={(e) => handleItemChange(i, 'amount', e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <Button variant="secondary" onClick={handleAddItem}>
                            Add Another Item
                        </Button>

                        <Form.Group className="mt-3">
                            <Form.Label>Previous Balance (KES)</Form.Label>
                            <Form.Control
                                type="number"
                                value={previousBalance}
                                onChange={(e) => setPreviousBalance(e.target.value)}
                            />
                        </Form.Group>

                        <div className="mt-3 text-end">
                            <strong>Total: KES {totalAmount.toFixed(2)}</strong><br />
                            <strong>Grand Total: KES {grandTotal.toFixed(2)}</strong>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSendInvoice} disabled={loading}>
                        {loading ? (
                            <Spinner as="span" animation="border" size="sm" />
                        ) : (
                            'Save Invoice'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* View Invoice Modal */}
            {/* View Invoice Modal */}
            <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Invoice Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedInvoice && (
                        <div id="invoice-preview" style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <img
                                        src={logo}
                                        alt="Dropoff Mtaani Logo"
                                        style={{ width: '120px', marginBottom: '10px' }}
                                    />
                                    <h5 style={{ marginBottom: '0' }}>Dropoff Mtaani</h5>
                                    <p style={{ margin: '0' }}>dropoffmtaani@gmail.com</p>
                                    <p style={{ margin: '0' }}>0727497852</p>
                                    <p style={{ margin: '0' }}>Nairobi, Kenya</p>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                    <h4 style={{ fontWeight: 'bold' }}>INVOICE</h4>
                                    <p>Date: {selectedInvoice.createdAt?.toDate().toLocaleDateString()}</p>
                                    <p>Invoice ID: {selectedInvoice.id}</p>
                                </div>
                            </div>

                            <hr style={{ margin: '20px 0' }} />

                            <div style={{ marginBottom: '20px' }}>
                                <h6>Bill To:</h6>
                                <p style={{ marginBottom: '0' }}>{getClientName(selectedInvoice.clientId)}</p>
                            </div>

                            <Table bordered size="sm">
                                <thead style={{ backgroundColor: '#f8f9fa' }}>
                                    <tr>
                                        <th>#</th>
                                        <th>Location</th>
                                        <th>Date</th>
                                        <th>Rate (KES)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedInvoice.items.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.orderFrom}</td>
                                            <td>{item.date}</td>
                                            <td>{Number(item.amount).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <div style={{ textAlign: 'right', marginTop: '20px' }}>
                                <p>Previous Balance: KES {Number(selectedInvoice.previousBalance || 0).toFixed(2)}</p>
                                <p>Total Amount: KES {Number(selectedInvoice.totalAmount || 0).toFixed(2)}</p>
                                <h5 style={{ fontWeight: 'bold' }}>Grand Total: KES {Number(selectedInvoice.grandTotal || 0).toFixed(2)}</h5>

                            </div>

                            <hr style={{ margin: '20px 0' }} />

                            <div style={{ textAlign: 'center', fontSize: '14px', color: '#666' }}>
                                <p>Thank you for your business.</p>
                                <p>Payment is due upon receipt unless otherwise agreed.</p>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowViewModal(false)}>Close</Button>
                    <Button variant="success" onClick={handleDownloadPDF}>Download PDF</Button>
                </Modal.Footer>
            </Modal>


        </div>
    );
}

export default ManualDash;
